const servicesIncludedWithWorryFree = [
  'wfg_initial_report',
  'llc_annual_report',
  'corp_annual_report',
  'corp_amendment',
  'llc_amendment'
];

// transforming from array to object to access data easily.
export default function getPricingDeviations(pricing, hasWorryFreeCompliance) {
  return pricing.reduce((group, val) => {
    const target = { ...val };

    /* If a customer has purchased worry free compliance, show the services
     * included in servicesIncludedWithWorryFree as free.
     */
    if (servicesIncludedWithWorryFree.includes(target.service) && hasWorryFreeCompliance) {
      target.amount = 0;
    }

    // eslint-disable-next-line no-param-reassign
    (group[val.service] = group[val.service] || []).push(target);

    return group;
  }, {});
}
